import { Outlet, createFileRoute } from '@tanstack/react-router';
import { requireAnonymous } from '../lib/auth/guards';

function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context }) => {
    await requireAnonymous(context.queryClient);
  },
  component: AuthLayout,
});
